export const getMarketingSource = (directoryId: number | undefined) => {
  switch (directoryId) {
    case 99:
      return "44999 Unknown Source";
    case 27:
      return "Boiler Service After Repair Email";
    case 5:
      return "BT Directory";
    case 76:
      return "Engineer Marketing";
    case 37:
      return "First Utility Inspection";
    case 205:
      return "Local Directory";
    case 201:
      return "Main Rightio Website";
    case 2:
      return "Thomson Directory";
    case 39:
      return "Website (Bing)";
    case 6:
      return "Website (Google)";
    case 87:
      return "Yell Heating Mobile";
    case 13:
      return "YELL HW";
    case 4:
      return "YELL LSP";
    case 56:
      return "Yell Recovery";
    case 19:
      return "YELL VIP";
    case 0:
      return "Yellow Pages";
    default:
      return "";
  }
};

// /* 44999 Unknown Source = WHITE with black text (Not sure if this is possible, just let me know)
// Boiler Service After Repair Email= GREEN
// BT Directory= RED
// Engineer Marketing= GREEN
// First Utility Inspection= PINK
// Local Directories= RED
// Main Rightio Website= TEAL
// Thomson Directory= RED
// Website (Bing)= ORANGE
// Website (Google)= PURPLE
// Yell Heating Mobile= YELLOW
// YELL HW= YELLOW
// YELL LSP= YELLOW
// Yell Recovery= YELLOW
// YELL VIP= YELLOW
// Yellow Pages= YELLOW */

export const getMarketingSourceClass = (directoryId: number | undefined) => {
  switch (directoryId) {
    case 99:
      return "white";
    case 27:
      return "green";
    case 5:
      return "red";
    case 76:
      return "green";
    case 37:
      return "pink";
    case 205:
      return "red";
    case 201:
      return "teal";
    case 2:
      return "red";
    case 39:
      return "orange";
    case 6:
      return "purple";
    case 87:
      return "yellow";
    case 13:
      return "yellow";
    case 4:
      return "yellow";
    case 56:
      return "yellow";
    case 19:
      return "yellow";
    case 0:
      return "yellow";
    default:
      return "";
  }
};
